export enum NotificationType {
  FOLLOW_REQUEST = 'follow_request', // 누군가 나에게 팔로우 요청을 보냈을 때 (비공개 계정)
  FOLLOW_ACCEPT = 'follow_accept', // 내가 보낸 팔로우 요청이 수락되었을 때
  FOLLOW = 'follow', // 공개 계정에서 누군가 나를 팔로우했을 때
  BOOKMARK = 'bookmark', // 나를 팔로우하고 있는 유저가 내가 리뷰 남긴 식당을 저장했을 때
  VISIT = 'visit', // 내가 팔로우한 유저가 내가 리뷰한 식당을 리뷰했을 때
  COMMENT = 'comment', // 내 피드에 댓글 작성 시
  LIKE = 'like', // 내 피드에 좋아요 추가 시
  TAG = 'tag', // 리뷰에 태그되었을 때
  MENTION = 'mention', // 댓글에서 @아이디로 언급되었을 때
  PLATE_PLACE_ADD = 'plate_place_add', // 플레이트리스트에 새 장소 추가 시
  PLATE_INVITE = 'plate_invite', // 플레이트리스트에 초대되었을 때
  MARKETING = 'marketing', // 광고·프로모션 (동의한 유저에게만)
  SERVICE_NOTICE = 'service_notice', // 앱 업데이트·점검·제안 처리 등 서비스 고지 (동의 무관)
  INQUIRY_REPLY = 'inquiry_reply', // 내가 남긴 고객센터 문의에 운영자가 답했을 때
}
